import React, { Component } from "react";
import { IconTextInput, CheckboxInput } from "../../../../forms/components";

class CreateMerchantStripeRatesTable extends Component {
	constructor(props) {
		super(props);

		this.state = {
			baseRate: props.baseRate[props.gateway],
			paymentTypes: Object.keys(props.MDRTypes),
			enable: props.enable[props.gateway],
		};
	}

	setGatewayRates = (gateway) => {
		const ratesEnabled =
			Object.values(this.state.enable).filter((i) => i === true).length > 0;

		this.props.setGatewayRates({ gateway }, !ratesEnabled);
	};

	render() {
		const { MDRTypes, gateway, enableRate } = this.props;
		const { baseRate, paymentTypes, enable } = this.state;

		const ratesEnabled =
			Object.values(enable).filter((i) => i === true).length > 0;

		return (
			<div>
				<div>
					<div className="uk-flex uk-flex-middle">
						<span>Enable</span>
						<div className="uk-margin-left">
							<label className="uk-form-label">
								<input
									className="uk-checkbox uk-margin-right"
									type="checkbox"
									checked={ratesEnabled}
									onChange={() => this.setGatewayRates(gateway)}
								/>
							</label>
						</div>
					</div>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</div>
				<div className="uk-overflow-auto" style={{ height: "40vh" }}>
					<div className="new-merchant-rate-table uk-overflow-auto uk-margin-small-bottom">
						<table className="uk-table uk-table-striped uk-table-middle">
							<thead>
								<tr>
									<th>Type</th>
									<th>Percentage</th>
									<th>Fixed Fees</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Default</td>
									<td>
										<IconTextInput
											id={`rates.${gateway}.default.percent`}
											name={`rates.${gateway}.default.percent`}
											icon="fa-solid-percent; ratio: 0.5"
											iconFlip={true}
											type="number"
											step=".01"
											min={baseRate.default.percent}
											placeholder="Percentage"
											disabled={!enable.default}
										/>
									</td>
									<td>
										<IconTextInput
											id={`rates.${gateway}.default.fixed`}
											name={`rates.${gateway}.default.fixed`}
											icon="fa-solid-dollar-sign; ratio: 0.5"
											type="number"
											step=".01"
											min={baseRate.default.fixed}
											placeholder="Fixed Fees"
											disabled={!enable.default}
										/>
									</td>
								</tr>
								{baseRate.under.map(
									({ amountInCents, percent, fixed }, index) => (
										<tr key={index}>
											<td>Under ${(amountInCents / 100).toFixed(2)}</td>
											<td>
												<IconTextInput
													id={`rates.${gateway}.under[${index}].percent`}
													name={`rates.${gateway}.under[${index}].percent`}
													icon="fa-solid-percent; ratio: 0.5"
													iconFlip={true}
													type="number"
													step=".01"
													min={percent}
													placeholder="Percentage"
													disabled={!enable.default}
												/>
											</td>
											<td>
												<IconTextInput
													id={`rates.${gateway}.under[${index}].fixed`}
													name={`rates.${gateway}.under[${index}].fixed`}
													icon="fa-solid-dollar-sign; ratio: 0.5"
													type="number"
													step=".01"
													min={fixed}
													placeholder="Fixed Fees"
													disabled={!enable.default}
												/>
											</td>
										</tr>
									)
								)}
							</tbody>
						</table>
					</div>
					<div className="new-merchant-rate-table uk-overflow-auto uk-margin-bottom">
						<table className="uk-table uk-table-striped uk-table-middle">
							<thead>
								<tr>
									<th>Payment Type</th>
									<th>Percentage</th>
									<th>Fixed Fees</th>
									<th className="uk-width-1-6">Enabled</th>
								</tr>
							</thead>
							<tbody>
								{paymentTypes.map((type) => {
									let prefix = `${gateway}.${type}`;
									let paymentRate = baseRate[type];

									if (paymentRate) {
										let isDisabled = enable ? !enable[type] : false;
										return (
											<tr key={`${prefix}-rate`}>
												<td>
													<img
														className="uk-img"
														src={`data:image/*;base64,${MDRTypes[type].image}`}
														width="35"
													/>
													<span className="uk-margin-small-left">
														{MDRTypes[type].label}
													</span>
												</td>
												<td>
													<IconTextInput
														id={`rates.${prefix}.percent`}
														name={`rates.${prefix}.percent`}
														icon="fa-solid-percent; ratio: 0.5"
														iconFlip={true}
														type="number"
														step=".01"
														min={paymentRate.percent}
														placeholder="Percentage"
														disabled={isDisabled}
													/>
												</td>
												<td>
													<IconTextInput
														id={`rates.${prefix}.fixed`}
														name={`rates.${prefix}.fixed`}
														icon="fa-solid-dollar-sign; ratio: 0.5"
														type="number"
														step=".01"
														min={paymentRate.fixed}
														placeholder="Fixed Fees"
														disabled={isDisabled || !paymentRate.fixed}
													/>
												</td>
												<td className="uk-width-1-5 uk-text-center">
													<CheckboxInput
														id={`enable.${prefix}`}
														name={`enable.${prefix}`}
														handleChange={(value) => enableRate(prefix, value)}
													/>
												</td>
											</tr>
										);
									}
								})}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		);
	}
}

export default CreateMerchantStripeRatesTable;
